import { BusinessHoursInternal } from 'components/discovery/store-locator/typing/store-locator.js'

export const dayCodeFor = (date: Date): string => {
  const jsDay = date.getDay()
  return jsDay === 0 ? '7' : String(jsDay)
}

const minutesSinceMidnight = (time: string): number | null => {
  const [hours, minutes] = time.split(':').map(Number)
  if (hours === undefined || minutes === undefined || isNaN(hours) || isNaN(minutes)) return null
  if (hours < 0 || hours > 23 || minutes < 0 || minutes > 59) return null
  return hours * 60 + minutes
}

const isWithin = (entry: BusinessHoursInternal, currentMinutes: number): boolean => {
  if (!entry.timeFrom || !entry.timeTo) return false

  const from = minutesSinceMidnight(entry.timeFrom)
  const to = minutesSinceMidnight(entry.timeTo)
  if (from === null || to === null) return false

  return currentMinutes >= from && currentMinutes < to
}

export const isOpenNow = (businessHours: BusinessHoursInternal[] | null | undefined, now: Date = new Date()): boolean => {
  const todayCode = dayCodeFor(now)
  const currentMinutes = now.getHours() * 60 + now.getMinutes()

  return (businessHours ?? [])
    .filter((entry) => entry.day === todayCode)
    .some((entry) => isWithin(entry, currentMinutes))
}
